import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=0254e21c&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"
import style0 from "./chart.vue?vue&type=style&index=0&id=0254e21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254e21c",
  null
  
)

export default component.exports